import { tv } from 'tailwind-variants'

import type { Color, LightColors } from '@ui-kit/types'

import type { ButtonType } from './types'

const variantsLabelColor: {
  [_key in Extract<Color, LightColors>]: Color
} = {
  grey100: 'black',
  white: 'black',
  successLight: 'deepForest',
  errorLight: 'deepForest',
  warningLight: 'deepForest',
  grey200: 'grey500',
  uiGreenOverlay: 'deepForest',
  playground1Light: 'playground1Dark',
  playground2Light: 'playground2Dark',
  playground3Light: 'playground3Dark',
  playground4Light: 'playground4Dark',
  playground5Light: 'playground5Dark',
  playground6Light: 'playground6Dark',
}

const isLightColor = (color: Color): color is LightColors => {
  return (
    color.includes('Light') ||
    color.includes('paleSpring') ||
    color.includes('Overlay') ||
    color === 'white' ||
    color === 'grey100' ||
    color === 'grey200'
  )
}

export const getLabelColor = (
  buttonType?: ButtonType,
  variantColor: Color = 'deepForest'
): Color => {
  switch (buttonType) {
    case 'outlined':
    case 'text': {
      return variantColor
    }
    default: {
      if (isLightColor(variantColor)) {
        return variantsLabelColor[variantColor]
      }
      return 'white'
    }
  }
}

export const button = tv({
  slots: {
    container:
      'relative flex min-w-button appearance-none items-center justify-center rounded-lg px-4 outline-none',
    labelContainer: 'flex flex-row items-center justify-center gap-x-2.5',
    iconContainer: 'max-h-8 min-h-6 min-w-6 max-w-8 overflow-hidden',
    label: '',
  },
  variants: {
    type: {
      default: {
        container: 'lg:hover:bg-deep-forest-600 lg:active:bg-deep-forest-600',
      },
      outlined: {
        container: 'lg:hover:opacity-70 lg:active:opacity-70',
      },
      text: {
        container: 'lg:hover:opacity-70 lg:active:opacity-70',
      },
    },
    disabled: {
      false: {
        container: 'web:transition web:duration-300 web:ease-in-out',
      },
      true: { container: 'opacity-30' },
    },
    size: {
      slim: { container: 'h-buttonSlim' },
      regular: { container: 'h-button' },
    },
    isLoading: {
      true: {
        labelContainer: 'opacity-0',
      },
    },
    uppercase: {
      true: {
        container: 'uppercase',
        label: 'font-modern-era-medium',
      },
    },
  },
  defaultVariants: {
    disabled: false,
    size: 'regular',
    type: 'default',
  },
})
